import {
  $$
} from './common.js';

/**
 * Reject modal lives on pages where approval.js may never load (e.g. listing
 * injected after DOMContentLoaded). Framework always loads modal.js, so bind here.
 */
function bindRejectModalControls(opts) {
  const textarea = document.getElementById('reject_reason');
  const button = document.getElementById('rejectButton');
  if (!textarea || !button) return;
  const sync = () => {
    button.disabled = textarea.value.trim() === '';
  };
  sync();
  textarea.oninput = sync;
  if (opts && opts.focus) {
    try {
      textarea.focus();
    } catch (_e) {
      /* ignore */
    }
  }
}

function getActiveReopenModal() {
  const modals = Array.from(document.querySelectorAll("[data-modal='reopen_modal']"));
  return (
    modals.find((modal) => !modal.classList.contains('hidden')) ||
    modals.find((modal) => modal.style.display && modal.style.display !== 'none') ||
    null
  );
}

function syncReopenButton(source) {
  const modal =
    source && source.closest
      ? source.closest("[data-modal='reopen_modal']")
      : getActiveReopenModal();
  const scope = modal || document;
  const textarea = scope.querySelector(
    '[data-ssr-reopen-reason], [name="reopen_reason"]'
  );
  const button = scope.querySelector('[data-ssr-reopen-submit], #reopenButton');
  if (button) button.disabled = !textarea || textarea.value.trim() === '';
}

// A reopen button renders one reopen_modal per grid row, so the DOM can hold
// several copies. Keep the first, drop the rest and hoist it to <body> before
// opening, otherwise openModal would unhide every stale copy at once.
window.liftSsrReopenModal = function () {
  const modals = Array.from(
    document.querySelectorAll("[data-modal='reopen_modal']")
  );
  if (!modals.length) return;
  const modal = modals[0];
  modals.slice(1).forEach((m) => m.remove());
  if (document.body && modal.parentElement !== document.body) {
    document.body.appendChild(modal);
  }
  const textarea = modal.querySelector(
    '[data-ssr-reopen-reason], [name="reopen_reason"]'
  );
  if (textarea) textarea.value = '';
  syncReopenButton();
  modal.classList.remove('hidden');
  modal.setAttribute('aria-modal', 'true');
};

function bindReopenModalControls(opts) {
  const scope = getActiveReopenModal() || document;
  const textarea = scope.querySelector(
    '[data-ssr-reopen-reason], [name="reopen_reason"]'
  );
  if (!textarea) return;
  syncReopenButton(textarea);
  textarea.oninput = () => syncReopenButton(textarea);
  window.syncSsrReopenButton = syncReopenButton;
  window.getSsrReopenReason = function () {
    const activeModal = getActiveReopenModal();
    const activeTextarea = (activeModal || document).querySelector(
      '[data-ssr-reopen-reason], [name="reopen_reason"]'
    );
    return activeTextarea ? activeTextarea.value : '';
  };
  if (opts && opts.focus) {
    try {
      textarea.focus();
    } catch (_e) {
      /* ignore */
    }
  }
}

function installRejectModalListeners() {
  const run = () => {
    bindRejectModalControls({ focus: false });
    bindReopenModalControls({ focus: false });
  };
  if (!window.__ssrReopenInputBound) {
    window.__ssrReopenInputBound = true;
    document.addEventListener(
      'input',
      function (event) {
        if (
          event.target &&
          event.target.matches &&
          event.target.matches('[data-ssr-reopen-reason], [name="reopen_reason"]')
        ) {
          syncReopenButton(event.target);
        }
      },
      true
    );
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function onReady() {
      run();
      if (document.body) {
        document.body.addEventListener('htmx:afterSettle', run);
      }
    });
  } else {
    run();
    if (document.body) {
      document.body.addEventListener('htmx:afterSettle', run);
    }
  }
}

if (typeof document !== 'undefined') {
  installRejectModalListeners();
}

export function openModal(name) {
  $$(`[data-modal='${name}']`).forEach(function(el) {
    if (name === 'cancel_modal' && el.parentElement !== document.body) {
      document.body.appendChild(el);
    }
    el.classList.remove('hidden');
    el.style.display = 'block';
    el.setAttribute('aria-modal', 'true');
  });
  if (name === 'reject_modal') {
    bindRejectModalControls({ focus: true });
  }
  if (name === 'reopen_modal') {
    bindReopenModalControls({ focus: true });
  }
  try {
    window.dispatchEvent(
      new CustomEvent('modalOpened', { detail: { modalId: name } })
    );
  } catch (_e) {
    /* ignore */
  }
}
export function closeModal(name, triggerOnCloseSelector) {
  $$(`[data-modal='${name}']`).forEach(function(el) {
    el.style.display = 'none';
    el.setAttribute('aria-modal', 'false');
  });
  if(triggerOnCloseSelector){
    window.htmx.trigger(triggerOnCloseSelector, "close")
  }
}
